import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "~/design-system/Button";
import { Card } from "~/design-system/Card";
import { Column, Columns } from "~/design-system/Columns";
import { Dialog, DialogClose, DialogContent } from "~/design-system/Dialog";
import { Stack } from "~/design-system/Stack";
import { Text } from "~/design-system/Text";

type MarkAllAsReadConfirmationDialogProps = {
  onConfirm: () => void;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

function MarkAllAsReadConfirmationDialog(
  props: MarkAllAsReadConfirmationDialogProps
) {
  const { t } = useTranslation();

  return (
    <Dialog open={props.open} setOpen={props.setOpen}>
      <DialogContent
        css={{ maxWidth: "$md" }}
        size="regular"
        stopClickPropagation
      >
        <Card padding="gutter">
          <Stack space="gutter">
            <Stack align="left">
              <Text size="standard" weight="medium" tone="secondary">
                {t(
                  "screens.UserNotificationsScreen.UserNotificationsScreenActions.MarkAllAsReadConfirmationDialog.confirmationText",
                  "Are you sure you want to mark all notifications as read?"
                )}
              </Text>
            </Stack>
            <Columns space="small">
              <Column>
                <DialogClose asChild>
                  <Button
                    variant="solid"
                    width="full"
                    dataClovisActionId="notifications-mark-all-as-read-dialog-cancel"
                  >
                    {t(
                      "screens.UserNotificationsScreen.UserNotificationsScreenActions.MarkAllAsReadConfirmationDialog.cancelButton",
                      "Cancel"
                    )}
                  </Button>
                </DialogClose>
              </Column>
              <Column>
                <Button
                  onClick={props.onConfirm}
                  variant="solid"
                  tone="brandAccent"
                  width="full"
                  dataClovisActionId="notifications-mark-all-as-read-dialog-confirm"
                >
                  {t(
                    "screens.UserNotificationsScreen.UserNotificationsScreenActions.MarkAllAsReadConfirmationDialog.confirmButton",
                    "Confirm"
                  )}
                </Button>
              </Column>
            </Columns>
          </Stack>
        </Card>
      </DialogContent>
    </Dialog>
  );
}

export { MarkAllAsReadConfirmationDialog };
